import RightsholderTrayMobile from '@Components/Navigations/RightsHoldersTrayMobile'
import RightsholderSubNavigation from '@Components/Navigations/RightsholderSubNavigation'
import clsx from 'clsx'
import HelpMenu from '@Components/Navigations/HelpMenu'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import SongwriterSubNavigation from '@Components/Navigations/SongwriterSubNavigation'
import './index.scss'
import PublicSearchNavLink from '@Components/Navigations/PublicSearchNavLink'

interface MobileNavigationProps {
    isOpen: boolean
}

const MobileSubNavigation = ({ isOpen }: MobileNavigationProps) => {
    const { rightsholderStore, rightsholderSearchStore, songwriterStore, songwriterSearchStore } =
        useContext(StoresContext)
    const currentRightsHolderId = rightsholderStore.optionalCurrentRightsholderId
    const rightsholderCount = rightsholderSearchStore.rightsholderCount
    const currentSongwriterId = songwriterStore.optionalCurrentSongwriterId
    const songwriterCount = songwriterSearchStore.songwriterCount

    return (
        <div className={clsx('links-block-nav', isOpen && 'open')}>
            {rightsholderCount > 1 && <RightsholderTrayMobile />}
            {rightsholderCount > 0 && currentRightsHolderId && <RightsholderSubNavigation />}
            {songwriterCount > 0 && currentSongwriterId && <SongwriterSubNavigation />}
            <PublicSearchNavLink />
            <HelpMenu />
        </div>
    )
}

export default MobileSubNavigation
